export default "__VITE_ASSET__ea56630e__"